import { render, staticRenderFns } from "./recording.vue?vue&type=template&id=07b1352c&scoped=true"
import script from "./recording.vue?vue&type=script&lang=js"
export * from "./recording.vue?vue&type=script&lang=js"
import style0 from "./recording.vue?vue&type=style&index=0&id=07b1352c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b1352c",
  null
  
)

export default component.exports